import { ItemsInventorySwitcherType, TItemsInventorySwitcherType } from '../components/ItemsInventoryListItemSwitcher/ItemsInventoryListItemSwitcher';
import { USER_PERMISSIONS } from '~/constants/user';
import { RESTRICTION_ACCESS } from '~/constants/integrations';
import { branchStore } from '~/mobx/branchStore';
import integrationsStore from '~/mobx/integrationStore';
import { hasPermissions, isDisabledByPos } from '~/utils/helpers';
import { formatPrice, formatPriceBranch } from '~/utils/formatter';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

type TData = {
  type: TItemsInventorySwitcherType;
  isCombo: boolean;
  branchFilterId: number;
};

export const itemsInventoryPosSetting = (data: TData): RESTRICTION_ACCESS | undefined => {
  const { type, isCombo, branchFilterId } = data;
  const { globalItemAvailability, globalItemStock, comboMealStatus } = integrationsStore.posRestrictions || {};

  const isPosBranch: boolean = _isPosBranch(branchFilterId);

  if (type === ItemsInventorySwitcherType.STOCK) {
    const stockPosRestrictions: boolean = isDisabledByPos(globalItemStock) && isPosBranch;

    return stockPosRestrictions ? globalItemStock : undefined;
  }

  const availabilityPosRestrictions: boolean = isDisabledByPos(isCombo ? comboMealStatus : globalItemAvailability) && isPosBranch;

  if (isCombo) return availabilityPosRestrictions ? comboMealStatus : undefined;
  return availabilityPosRestrictions ? globalItemAvailability : undefined;
};

const _isPosBranch = (branchFilterId: number): boolean => {
  return Boolean(branchStore.branches.find((branch) => branch.id === branchFilterId)?.pos_service_id);
};

export const itemsInventoryAvailableEdit = (type: TItemsInventorySwitcherType): boolean => {
  if (type === ItemsInventorySwitcherType.STOCK) {
    return hasPermissions(USER_PERMISSIONS.ITEMS_GLOBAL_STOCK_EDIT.concat(USER_PERMISSIONS.ITEMS_IN_BRANCH_STOCK_EDIT));
  }

  return hasPermissions(USER_PERMISSIONS.ITEMS_GLOBAL_STATUS_EDIT.concat(USER_PERMISSIONS.ITEMS_IN_BRANCH_STATUS_EDIT));
};

/**
 * Price formatting depending on branch
 *
 * @see formatPrice
 * @param {(string | number)} price
 * @param {IPickerOption} branchFilter
 */
export const itemsInventoryFormatPrice = (price: string | number, branchFilter?: IPickerOption) => {
  if (branchFilter) {
    return formatPriceBranch(price, branchFilter.data);
  }

  return formatPrice(price);
};
